import axios from '../../axios'
import Axios, { AxiosRequestConfig } from 'axios'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { dashboardStore } from './dashboard.store'

type Balance = {
  creditBalance: number;
  draftCreditBalance: number;
}

export class EnterpriseStore {
  isLoadingBalance: boolean = false
  balance: Balance | null = null;

  cancelTokenSource = () => {}

  constructor() {
    makeObservable(this, {
      isLoadingBalance: observable,
      balance: observable,
      setIsLoadingBalance: action,
      setBalance: action,
      availableBalance: computed,
    })
  }

  reset = () => {
    this.cancelTokenSource?.()
    this.balance = null
    this.isLoadingBalance = false
    this.cancelTokenSource = () => {}
  }

  setIsLoadingBalance = (value: boolean) => {
    this.isLoadingBalance = value
  }
  setBalance = (value: Balance) => {
    this.balance = value
  }

  get availableBalance() {
    return (this.balance?.creditBalance ?? 0) - (this.balance?.draftCreditBalance ?? 0)
  }

  getBalance = () => {
    if (typeof this.cancelTokenSource == 'function') {
      this.cancelTokenSource()
    }
    const cancelTokenSource = Axios.CancelToken.source()

    this.setIsLoadingBalance(true)
    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
    }
    const { enterpriseId }= dashboardStore.userData || {}
    axios
      .get(`/management/api/v1/enterprise/${enterpriseId}/balance`, config)
      .then(({ data }) => {
        this.setBalance(data)
      })
      .finally(() => {
        this.setIsLoadingBalance(false)
      })

    this.cancelTokenSource = cancelTokenSource.cancel
  }
}

export const enterpriseStore = new EnterpriseStore()
